import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBirthdays } from 'actions/Birthdays';

import KAvatar from 'components/KJRN/KAvatar';
import map from 'lodash/map';
import TLoading from './TLoading';
import TMessage from './TMessage';

const styles = {
  container: {
    width: 'calc(100% - 52px)',
    height: 'calc(100% - 36px)',
    paddingLeft: 26,
    paddingRight: 26,
    paddingTop: 26,
    paddingBottom: 10,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  birthday: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    minWidth: 130,
    padding: 12,
    textAlign: 'center',
  },
  name: {
    marginTop: 8,
    height: 36,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  age: {
    marginTop: 4,
    fontWeight: 600,
  },
};

const TBirthdays = () => {
  const dispatch = useDispatch();
  const { birthdays, loaded, hasError } = useSelector(state => state.BirthdaysReducer);
  const { valuesByKey } = useSelector(state => state.WebValuesReducer);

  useEffect(() => {
    dispatch(fetchBirthdays());
  }, []);

  if (hasError) {
    return <TMessage type="error" message="tile.birthdays.error" />;
  }

  if (!loaded) {
    return <TLoading />;
  }

  if (!birthdays || !birthdays.length) {
    return <TMessage message="tile.birthdays.empty" />;
  }
  return (

    <div style={styles.container}>
      {map(birthdays, (birthday, i) => (
        <div key={`${i}`} style={styles.birthday}>
          <KAvatar imgSrc={birthday.ImageUrl} masterId={birthday.EmployeeMasterID} />
          <div style={styles.name}>{birthday.Name}</div>
          {(!valuesByKey['Hide.Birthdays.Age'] || valuesByKey['Hide.Birthdays.Age'].Value !== 'true') &&
          <div style={styles.age}>{birthday.Age}</div>
            }
        </div>
        ))}
    </div>
  );
};

export default TBirthdays;



// WEBPACK FOOTER //
// ./src/containers/tiles/TBirthdays.js